import {Private} from '@apps-common/auth-react';
import {CircularProgress, Stack, useColorScheme} from '@mui/material';
import React, {Suspense, lazy, useEffect} from 'react';
import {Route, Routes} from 'react-router';
import Header from '../components/header/index.jsx';
import MyStories from './my-stories.jsx';
import NotFound from './not-found.jsx';
import StoryList from './story-list/index.jsx';

const Viewer = lazy(() => import('./viewer/index.jsx'));
const Wizard = lazy(() => import('./wizard/index.jsx'));

function Loading() {
  return (
    <Stack
      sx={{
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Stack>
  );
}

const Pages = () => {
  const {setMode} = useColorScheme();

  // Force dark mode
  useEffect(() => {
    setMode('dark');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/callback" element={<Loading />} />
          <Route
            path="/create"
            element={
              <Private>
                <Wizard />
              </Private>
            }
          />
          <Route
            path="/my-stories"
            element={
              <Private>
                <MyStories />
              </Private>
            }
          />

          <Route exact path="/:storyId" element={<Viewer />} />
          <Route exact path="/" element={<StoryList />} />
          <Route element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default Pages;
